module.exports = __webpack_public_path__ + "static/media/inventory-management.0e81f220.md";